export interface Region {
  code: string
  name: string
}

export const REGIONS: Region[] = [
  { code: 'nacional', name: 'Total Nacional' },
  { code: 'andalucia', name: 'Andalucía' },
  { code: 'aragon', name: 'Aragón' },
  { code: 'asturias', name: 'Asturias' },
  { code: 'baleares', name: 'Illes Balears' },
  { code: 'canarias', name: 'Canarias' },
  { code: 'cantabria', name: 'Cantabria' },
  { code: 'castilla-leon', name: 'Castilla y León' },
  { code: 'castilla-mancha', name: 'Castilla-La Mancha' },
  { code: 'cataluna', name: 'Cataluña' },
  { code: 'valencia', name: 'Comunitat Valenciana' },
  { code: 'extremadura', name: 'Extremadura' },
  { code: 'galicia', name: 'Galicia' },
  { code: 'madrid', name: 'Comunidad de Madrid' },
  { code: 'murcia', name: 'Región de Murcia' },
  { code: 'navarra', name: 'Navarra' },
  { code: 'pais-vasco', name: 'País Vasco' },
  { code: 'rioja', name: 'La Rioja' },
  { code: 'ceuta', name: 'Ceuta' },
  { code: 'melilla', name: 'Melilla' },
]
